export const HOST:string = ' https://superfun-nwa.com' // PROD = https://superfun-nwa.com